import { render, staticRenderFns } from "./Norisen.vue?vue&type=template&id=0a659f00&"
import script from "./Norisen.vue?vue&type=script&lang=js&"
export * from "./Norisen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports